async function request(path, options = {}) {
  const response = await fetch(path, {
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
    credentials: "include",
    ...options,
  });

  const contentType = response.headers.get("content-type") || "";
  const data = contentType.includes("application/json") ? await response.json() : await response.text();

  if (!response.ok) {
    const message = typeof data === "object" && data?.error ? data.error : "Request failed";
    throw new Error(message);
  }

  return data;
}

export const api = {
  health: () => request("/api/health"),
  me: () => request("/api/auth/me"),
  setup: (payload) => request("/api/auth/setup", { method: "POST", body: JSON.stringify(payload) }),
  login: (payload) => request("/api/auth/login", { method: "POST", body: JSON.stringify(payload) }),
  logout: () => request("/api/auth/logout", { method: "POST" }),
  getConfig: () => request("/api/config"),
  saveConfig: (payload) => request("/api/config", { method: "POST", body: JSON.stringify(payload) }),
  listProjects: () => request("/api/projects"),
  getProject: (id) => request(`/api/projects/${id}`),
  saveProject: (payload) => request("/api/projects", { method: "POST", body: JSON.stringify(payload) }),
  createRun: (projectId, payload) => request(`/api/projects/${projectId}/runs`, { method: "POST", body: JSON.stringify(payload) }),
  upsertRun: (payload) => request("/api/projects/upsert-run", { method: "POST", body: JSON.stringify(payload) }),
  executeRun: (payload) => request("/api/execute-run", { method: "POST", body: JSON.stringify(payload) }),
  listJobs: (params = {}) => {
    const search = new URLSearchParams(params);
    return request(`/api/jobs${search.toString() ? `?${search.toString()}` : ""}`);
  },
  getJob: (id) => request(`/api/jobs/${id}`),
  createJob: (payload) => request("/api/jobs", { method: "POST", body: JSON.stringify(payload) }),
  createBatchJobs: (payload) => request("/api/jobs/batch", { method: "POST", body: JSON.stringify(payload) }),
  getLogs: (limit = 200) => request(`/api/logs?limit=${limit}`),
};
